import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfigProvider, theme } from "antd";
import { observer } from "mobx-react";
import { useMemo } from "react";
import { UserPill } from "./userPill.js";
import { UserPillSkeleton } from "./userPillSkeleton.js";
import { AccountVersionSwitch } from "../../../../components/accountVersionSwitch.js";
import { useStores } from "../../../../store/stores.js";
import { __ } from "../../../../utils/i18n.js";
const SlimHero = observer(({ isAnonymous = false })=>{
    const { accountV2Store, optionStore } = useStores();
    const { token } = theme.useToken();
    const isLoggedIn = !!accountV2Store.session?.user;
    const { isHydrating } = accountV2Store;
    const style = useMemo(()=>({
            "--rc-account-v2-hero-overlay-url": `url("${optionStore.publicUrl}images/bg-overlay-01.webp")`
        }), [
        optionStore.publicUrl
    ]);
    return /*#__PURE__*/ _jsx("section", {
        className: "rc-account-v2-hero",
        style: style,
        children: /*#__PURE__*/ _jsxs("div", {
            className: `rc-account-v2-hero__inner${isAnonymous ? " rc-account-v2-hero__inner--centered" : ""}`,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-hero__copy",
                    children: /*#__PURE__*/ _jsx("h1", {
                        className: "rc-account-v2-hero__title",
                        children: __("Customer Center")
                    })
                }),
                !isAnonymous && /*#__PURE__*/ _jsxs("div", {
                    className: "rc-account-v2-hero__right",
                    children: [
                        !isHydrating && /*#__PURE__*/ _jsx("div", {
                            className: "rc-account-v2-hero__switch rc-account-v2-hero__switch--reveal",
                            children: /*#__PURE__*/ _jsx(ConfigProvider, {
                                theme: {
                                    components: {
                                        Segmented: {
                                            itemColor: token.colorBgContainer,
                                            itemHoverColor: token.colorBgContainer,
                                            itemSelectedColor: token.colorTextHeading
                                        }
                                    }
                                },
                                children: /*#__PURE__*/ _jsx(AccountVersionSwitch, {
                                    active: "v2"
                                })
                            })
                        }),
                        isLoggedIn ? /*#__PURE__*/ _jsx(UserPill, {}) : isHydrating ? /*#__PURE__*/ _jsx(UserPillSkeleton, {}) : null
                    ]
                })
            ]
        })
    });
});
export { SlimHero };
